import React from "react";

/** returns a footer page */
export const FooterComponent = () => {
  return (
    <div className="row">
      <hr />
      <p className="footer-agreement">
        <strong>GreenLink Networks</strong>
        <br />
        (888) 972 8802 &#8226; {""}
        <a
          href="mailto:partners@greenlinknetworks.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          partners@greenlinknetworks.com
        </a>
        <br />
        16415 Addison Rd, Addison, TX 75001, USA.
        <br />
        &copy; All rights reserved. GreenLink Networks.
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Layout/FooterComponent.js